import addBorderInHighContrastMode from '@/lib/styling/addBorderInHighContrastMode';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { lighten } from '@mui/system';

type FileChipProps = {
  useErrorMode?: boolean;
};

const FileChip = styled('li')<FileChipProps>(
  ({ theme, useErrorMode }) => ({
    marginRight: 8,
    marginBottom: 8,
    height: 32,
    color: useErrorMode
      ? theme.isDark
        ? lighten(theme.palette.error.light, 0.1)
        : theme.palette.error.dark
      : undefined,
    backgroundColor: useErrorMode
      ? theme.isDark
        ? theme.palette.error.dark
        : lighten(theme.palette.error.light, 0.8)
      : theme.palette.action.hover,
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 4,
    overflow: 'hidden',
  }),
  addBorderInHighContrastMode,
  addHighContrastStyles(({ theme, useErrorMode }) => {
    if (theme.isDark && !useErrorMode) {
      return {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      };
    }
  }),
);

export default FileChip;
